__webpack_require__.p = "/~mocno/hipo/";